import { c as _c } from "react/compiler-runtime";
import { SelectInput, sortByLabel } from '@newfront-insurance/core-ui';
import { uniq } from 'lodash';
import * as React from 'react';
import type { JSX } from 'react';
import type { Carrier } from '../../../types';
export interface Props {
  data?: Carrier[];
  value?: string | null;
  onChange?: (value?: string | null) => unknown;
  disabled?: boolean;
  name?: string;
  innerRef?: React.MutableRefObject<HTMLSelectElement>;
  showSelectAnOption?: boolean;
}
export function CarrierSelect(props) {
  const $ = _c(14);
  const {
    onChange,
    value,
    disabled,
    name,
    innerRef,
    showSelectAnOption,
    data: t0
  } = props;
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const data = t1;
  let t2;
  if ($[2] !== data) {
    t2 = data ? uniq(data).map(_temp).sort(sortByLabel) : [];
    $[2] = data;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const carrierOptions = t2;
  let t3;
  if ($[4] !== onChange) {
    t3 = carrier_0 => {
      if (onChange) {
        onChange(carrier_0);
      }
    };
    $[4] = onChange;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== carrierOptions || $[7] !== disabled || $[8] !== innerRef || $[9] !== name || $[10] !== showSelectAnOption || $[11] !== t3 || $[12] !== value) {
    t4 = <SelectInput name={name} options={carrierOptions} onChange={t3} value={value} innerRef={innerRef} disabled={disabled} showSelectAnOption={showSelectAnOption} />;
    $[6] = carrierOptions;
    $[7] = disabled;
    $[8] = innerRef;
    $[9] = name;
    $[10] = showSelectAnOption;
    $[11] = t3;
    $[12] = value;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
function _temp(carrier) {
  return {
    value: carrier.id,
    label: carrier.name
  };
}